export default __webpack_public_path__ + "static/media/kolibri-loader.8ba46e72.gif";